const cancelReasons = {
	canceledBySuperadmin: 'canceled%20by%20super-admin',
	// Set by the sync when a channel moves an order to another warehouse; never picked by hand.
	warehouseChangedOnChannel: 'warehouse%20changed%20on%20channel',
};

export { cancelReasons };
